import { ChangeDetectionStrategy, Component, Inject, OnInit,Renderer2,PLATFORM_ID } from "@angular/core";
import { RouterModule, RouterOutlet } from "@angular/router";
import { HeaderPanelComponent } from "./header-panel/header-panel.component";
import { BreadCrumbsComponent } from "./bread-crumbs/bread-crumbs.component";
import { AuthService } from "../services/auth.service";
import { environment } from "../environments/environment";
import { InactivityService } from "../services/inactivity.service";
import { DOCUMENT,isPlatformBrowser } from "@angular/common";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [RouterOutlet, RouterModule, HeaderPanelComponent, BreadCrumbsComponent],
  providers: [AuthService, InactivityService],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  constructor(private inactivityService: InactivityService,@Inject(DOCUMENT
  ) private document: Document,private renderer: Renderer2,@Inject(PLATFORM_ID) private platformId: any) {
    console.log('environment :  ' + environment.api_base_url);
  }
  title = "passlink-management-app";

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.setDynamicFavicon();

      // Listen for theme changes
      window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
        this.setDynamicFavicon();
      });
    }
  }
  setDynamicFavicon(): void {
    const theme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    const faviconPath = theme === 'dark' ? 'assets/logo-DarkMode.svg' : 'assets/logo-LightMode.svg';

    this.setFavicon(faviconPath);
  }

  setFavicon(faviconUrl: string): void {
    let link: HTMLLinkElement = this.renderer.createElement('link');
    link.rel = 'icon';
    link.href = faviconUrl;

    // Remove any existing favicon element before appending the new one
    const existingFavicon = document.querySelector('link[rel="icon"]');
    if (existingFavicon) {
      this.renderer.removeChild(document.head, existingFavicon);
    }

    this.renderer.appendChild(document.head, link);
  }

}
